var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"header",on:{"click":function($event){return _vm.onClick()}}},[_c('div',{staticClass:"header__logo-wrapper"},[_c('Logo')],1)]),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('scroll-btn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=674a81de&
// module id = null
// module chunks = 